"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SocketService = void 0;
const tslib_1 = require("tslib");
const frontend_infra_logger_1 = require("@forto-dev/frontend-infra-logger");
const lodash_es_1 = require("lodash-es");
const nanoid_1 = require("nanoid");
const socket_io_client_1 = tslib_1.__importDefault(require("socket.io-client"));
class SocketService {
    constructor(token, props, logWarn) {
        this.createDomainEventsListeners = (domainEventsMap) => {
            domainEventsMap.forEach((domainEvent) => {
                if (!this.socket.hasListeners(domainEvent.eventType)) {
                    this.socket.on(domainEvent.eventType, (data) => domainEvent.callback(data));
                }
            });
            if (!this.socket.hasListeners('error')) {
                this.socket.on('error', (error) => {
                    this.logSocketError('socket.io error event', error);
                });
            }
            if (!this.socket.hasListeners('connect_error')) {
                this.socket.on('connect_error', (error) => {
                    this.logSocketError('socket.io connect_error event', error);
                });
            }
        };
        this.logSocketError = (message, error) => {
            if ((0, lodash_es_1.isError)(error)) {
                this.logWarn(new frontend_infra_logger_1.CustomErrorWithCause(message, { cause: error }).toString());
            }
            else {
                const stringifiedError = (0, lodash_es_1.isObject)(error) ? JSON.stringify(error) : error;
                this.logWarn(`${message}: ${stringifiedError}`);
            }
        };
        this.removeDomainEventsListeners = (domainEventsMap) => {
            domainEventsMap.forEach((domainEvent) => {
                this.socket.removeListener(domainEvent.eventType, domainEvent.callback);
            });
        };
        this.disconnect = () => {
            this.socket.disconnect();
        };
        const { socketUrl, nameSpace, params } = props || {};
        this.logWarn = logWarn;
        if (!token) {
            this.logSocketError('SocketService: token is required', props);
        }
        const pathBasedRouting = socketUrl?.startsWith('/');
        const socketOrigin = pathBasedRouting ? '' : socketUrl;
        const socketPath = pathBasedRouting ? socketUrl : '';
        this.socket = (0, socket_io_client_1.default)(`${socketOrigin}${nameSpace}`, {
            path: `${socketPath}/socket.io/`,
            withCredentials: true,
            query: {
                ...params,
                sticky: (0, nanoid_1.nanoid)(9),
            },
            extraHeaders: {
                Authorization: `Bearer ${token}`,
            },
            forceNew: true,
        });
    }
}
exports.SocketService = SocketService;
//# sourceMappingURL=SocketService.js.map